import { OnClickEvent } from "../Components"
import { BlockFieldInputs } from "./Block"
import { Icon, Icons } from "./Icon"

interface DeleteButtonProps {
  onClick?: OnClickEvent;
}

export function DeleteButton({ onClick }: DeleteButtonProps) {
  return (
    <BlockFieldInputs className="DeleteButton">
      <Icon icon={Icons.Trash} className="icon-delete" onClick={onClick} />
    </BlockFieldInputs>
  );
}
